import { SlotGameType1_2 } from "../SlotGameType1_2";
export class LuckyFire100_2 extends SlotGameType1_2{}